import { render, staticRenderFns } from "./scanInputGoods.vue?vue&type=template&id=8d970a88&scoped=true"
import script from "./scanInputGoods.vue?vue&type=script&lang=js"
export * from "./scanInputGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d970a88",
  null
  
)

export default component.exports